@if (isOpen) {
  @if (!inline) {
  <button
    class="sm-global-search-results__backdrop"
    [class.sm-global-search-results__backdrop--relocation]="relocationMode"
    type="button"
    [disabled]="relocationMode"
    [attr.aria-label]="closeLabel || null"
    (click)="requestClose()">
  </button>
  }

  <section class="sm-global-search-results" [attr.role]="inline ? 'region' : 'dialog'" aria-live="polite" [attr.aria-label]="title || null">
    @if (backLabel) {
      <button class="sm-global-search-results__back" type="button"
        data-relocation-path-back="" [attr.aria-label]="backLabel"
        (click)="requestBack()">
        <ion-icon name="arrow-back-outline" aria-hidden="true"></ion-icon>
        <span>{{ backLabel }}</span>
      </button>
    }
    <header class="sm-global-search-results__header">
      @if (!fullSearchLabel) {
      <div class="sm-global-search-results__header-copy">
        <p class="sm-global-search-results__eyebrow">{{ title }}</p>
        <h2 class="sm-global-search-results__query">
          @if (query.trim()) {
            {{ query.trim() }}
          } @else {
            {{ title }}
          }
        </h2>
      </div>
      }

      <div class="sm-global-search-results__header-actions">
        @if (fullSearchLabel) {
          <sm-action-button variant="ghost" size="xs" trailingIconName="arrow-forward-outline" (click)="fullSearchRequested.emit()">{{ fullSearchLabel }}</sm-action-button>
        }
      <button
        class="sm-global-search-results__close"
        type="button"
        [disabled]="relocationMode"
        [attr.aria-label]="closeLabel || null"
        (click)="requestClose()">
        <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
      </button>
      </div>
    </header>
    @if (isLoading) {
      <div class="sm-global-search-results__message">{{ loadingLabel }}</div>
    } @else if (error) {
      <div class="sm-global-search-results__message sm-global-search-results__message--error">
        <span>{{ errorPrefix }} {{ error }}</span>
        @if (retryLabel) {
          <button
            type="button"
            class="sm-global-search-results__retry"
            [disabled]="relocationMode"
            (click)="retryRequested.emit()">
            <ion-icon name="refresh-outline" aria-hidden="true"></ion-icon>
            <span>{{ retryLabel }}</span>
          </button>
        }
      </div>
    } @else if (hasResults) {
      <div
        class="sm-global-search-results__groups"
        [attr.data-relocation-sibling-scroll]="relocationMode ? '' : null">
        @if (hasMoreContainers || hasMoreItems) {
          <p class="sm-global-search-results__limit-notice" role="status">{{ limitLabel }}</p>
        }

        @if (containers.length) {
          <section class="sm-global-search-results__group" aria-label="{{ containersTitle }}">
            <header class="sm-global-search-results__group-header">
              <h3>{{ containersTitle }}</h3>
              <span>{{ containers.length }}</span>
            </header>

            <div class="sm-global-search-results__rows">
              @for (container of containers; track trackById($index, container)) {
                <sm-global-search-container-result
                  [class.is-relocation-drop-target]="getContainerRelocationTargetId(container) !== null"
                  [attr.data-relocation-drop-target]="getContainerRelocationTargetId(container)"
                  [attr.data-relocation-drop-accepts]="getContainerRelocationTargetId(container) ? 'all' : null"
                  [attr.data-relocation-drop-target-name]="getContainerRelocationTargetId(container) ? container.name : null"
                  [result]="container"
                  [searchQuery]="highlightQuery"
                  [emptyDescriptionLabel]="containerEmptyDescriptionLabel"
                  [openLabelTemplate]="containerOpenLabelTemplate"
                  [rootLocationLabel]="rootLocationLabel"
                  [currentLabel]="containerCurrentLabel"
                  [inventoryMenu]="getContainerInventoryMenu(container)"
                  [menuItems]="relocationMode || container.canEdit === false ? [] : containerMenuItems"
                  [menuAriaLabelTemplate]="containerMenuAriaLabelTemplate"
                  (open)="handleContainerOpen(container)"
                  (menuItemSelect)="handleContainerMenuItemSelect(container, $event)">
                </sm-global-search-container-result>
              }
            </div>
          </section>
        }

        @for (section of displayedItemSections; track section.title) {
          <section class="sm-global-search-results__group" [attr.aria-label]="section.title">
            <header class="sm-global-search-results__group-header">
              <h3>{{ section.title }}</h3>
              <span>{{ section.items.length }}</span>
            </header>

            <div class="sm-global-search-results__rows">
              @for (item of section.items; track trackById($index, item)) {
                <sm-global-search-item-result
                  [result]="item"
                  [searchQuery]="highlightQuery"
                  [menuItems]="itemMenuItems"
                  [emptyDescriptionLabel]="itemEmptyDescriptionLabel"
                  [openLabelTemplate]="itemOpenLabelTemplate"
                  [menuAriaLabelTemplate]="itemMenuAriaLabelTemplate"
                  (open)="handleItemOpen(item)"
                  (menuItemSelect)="handleItemMenuItemSelect(item, $event)">
                </sm-global-search-item-result>
              }
            </div>
          </section>
        }
      </div>
    } @else {
      <div class="sm-global-search-results__empty-state">
        <h3>{{ emptyTitle }}</h3>
        @if (emptyDescriptionTemplate.trim()) {
          <p>{{ formatTemplate(emptyDescriptionTemplate, {query: query.trim()}) }}</p>
        }
      </div>
    }
  </section>
}
